/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveLPTokenMinterLike,
  ICurveLPTokenMinterLikeInterface,
} from "../ICurveLPTokenMinterLike";

const _abi = [
  {
    inputs: [],
    name: "minter",
    outputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurveLPTokenMinterLike__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveLPTokenMinterLikeInterface {
    return new utils.Interface(_abi) as ICurveLPTokenMinterLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveLPTokenMinterLike {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurveLPTokenMinterLike;
  }
}
